export default {
  // sm: `
  // 진심이 담긴 기술
  // `,
  sm: `
  친환경 데이터센터의 기준
  `,
};
